/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=6acce587"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=6acce587&lang=scss"

import exportComponent from "/root/.jenkins/workspace/高保障-门户内蒙古医科-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__